import "./App.css";
import {
  Route,
  Routes,
  Navigate,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { useState, useEffect, useRef } from "react"; // <-- useRef added
import Header from "./Header.js";
import Footer from "./Footer.js";

// Pages
import HomePage from "./pages/employees/Home.js";
import LoginPage from "./pages/employees/LoginPage.js";
import UserTime from "./pages/employees/User-time.js";
import MeetingPage from "./pages/employees/MeetingPage.js";
import MyordergPage from "./pages/employees/Myorder-page.js";
import DistributorveryfectionPage from "./pages/employees/DistributorveryfectionPage.js";
import LeavesPage from "./pages/employees/Leavespage.js";

// Admin pages
import AdminLoginPage from "./pages/admin/AdminLoginPage.js";
import Dashboard from "./pages/admin/AdminDashboard.js";
import EmployeePage from "./pages/admin/EmployeeListPage.js";
import AttendancePage from "./pages/admin/AttendancePage.js";
import MeetingListPage from "./pages/admin/MeetingListPage.js";
import AddEmployeePage from "./pages/admin/AddEmployeepage.js";
import CsvPage from "./pages/admin/Csvpage.js";
import EmployeeLocationPage from "./pages/admin/EmployeeLocationPage.js";
import PurchasePage from "./pages/admin/PurchasePage.js";
import PurchaseListPage from "./pages/admin/PurchaseListpage.js";
import DistributorListPage from "./pages/admin/DistributorListpage.js";
import OrderListPage from "./pages/admin/OrderListPage.js";
import ArchieveEmployeePage from "./pages/admin/ArchieveEmployeepage.js";
import AttendanceViewPage from "./pages/admin/AttendanceView.js";
import ApiPage from "./pages/admin/api-key-page.js";
import FarmerDetailsPage from "./pages/admin/Farmer-DetailsPage.js";
import DealerDetailsPage from "./pages/admin/DealerDetailspage.js";
import LeaveDetailsPage from "./pages/admin/LeaveDetailsPage.js";
import AppIdPage from "./pages/admin/App-id-page.js";
import EmployeeRouteMapPage from "./pages/admin/Livelocationpage.js";

// Layout
import AdminLayout from "./components/admin/admin.js";
import TooltipManager from "./components/admin/TooltipManager.js";

const ProtectedRoute = ({ children }) => {
  const authToken =
    localStorage.getItem("authToken") || localStorage.getItem("adminAuthToken");
  if (!authToken) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

const App = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(
    !!(
      localStorage.getItem("authToken") ||
      localStorage.getItem("adminAuthToken")
    )
  );

  // Optional: monitor token changes (e.g., after login/logout)
  useEffect(() => {
    const handleStorageChange = () => {
      setIsLoggedIn(
        !!(
          localStorage.getItem("authToken") ||
          localStorage.getItem("adminAuthToken")
        )
      );
    };
    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("adminAuthToken");
    setIsLoggedIn(false);
    navigate("/login");
  };

  const currentVersion = useRef(null); // ✅ useRef App component ke top me hona chahiye

useEffect(() => {
  const checkVersion = () => {
    fetch(`/version.json?t=${new Date().getTime()}`)
      .then(res => res.json())
      .then(data => {
        const latestVersion = data.version;
        const storedVersion = localStorage.getItem("appVersion");

        // Pehli baar visit
        if (!storedVersion) {
          localStorage.setItem("appVersion", latestVersion);
          currentVersion.current = latestVersion;
          alert("Welcome! You are using version " + latestVersion);
        } 
        // Version change hone par
        else if (storedVersion !== latestVersion) {
          alert("New version is available. Reloading...");
          localStorage.setItem("appVersion", latestVersion);
          window.location.href = window.location.href; // ✅ Notice ke bina page reload karega
        }
      })
      .catch(err => {
        console.error("Version check failed:", err);
      });
  };

  checkVersion(); // Page load par version check ho

  const interval = setInterval(() => {
    checkVersion(); // 30 second me baar baar check hoga
  }, 30000);

  return () => clearInterval(interval);
}, []);


  // Modified section starts here 👇
  const hideHeaderRoutes = ["/admin-dashboard", "/admin-login"];
  const shouldHideHeader = hideHeaderRoutes.some((route) =>
    location.pathname.startsWith(route)
  );


  
  const hideFooterRoutes = ["/admin-dashboard", "/admin-login"];
  const shouldHideFooter = hideFooterRoutes.some((route) =>
    location.pathname.startsWith(route)
  );

  return (
    <>
    <TooltipManager />
    
      {!shouldHideHeader && (
        <Header
          isLoggedIn={isLoggedIn}
          handleLogout={handleLogout}
          setSearchQuery={() => {}} // if unused, you can pass empty fn
        />
      )}

      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<HomePage />} />
        <Route
          path="/login"
          element={<LoginPage setIsLoggedIn={setIsLoggedIn} />}
        />
        <Route path="/admin-login" element={<AdminLoginPage />} />

        {/* Employee/User Routes (Protected) */}
        <Route
          path="/employee-attendance"
          element={
            <ProtectedRoute>
              <UserTime />
            </ProtectedRoute>
          }
        />
        <Route
          path="/meeting"
          element={
            <ProtectedRoute>
              <MeetingPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/my-order"
          element={
            <ProtectedRoute>
              <MyordergPage />
            </ProtectedRoute>
          }
        />


<Route
          path="/leaves"
          element={
            <ProtectedRoute>
              <LeavesPage />
            </ProtectedRoute>
          }
        />



        <Route
          path="/distributor-verification"
          element={
            <ProtectedRoute>
              <DistributorveryfectionPage />
            </ProtectedRoute>
          }
        />

        {/* Admin Routes using AdminLayout */}
        <Route
          path="/admin-dashboard"
          element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="employee-list" element={<EmployeePage />} />
          <Route path="employee-attendances" element={<AttendancePage />} />
          <Route path="meetings-list" element={<MeetingListPage />} />
          <Route path="add-employee" element={<AddEmployeePage />} />
          <Route path="csv" element={<CsvPage />} />
          <Route path="employee-location" element={<EmployeeLocationPage />} />
          <Route path="purchase" element={<PurchasePage />} />
          <Route path="purchase-details" element={<PurchaseListPage />} />
          <Route path="distributor-details" element={<DistributorListPage />} />
          <Route path="order-details" element={<OrderListPage />} />
          <Route path="archived-employees" element={<ArchieveEmployeePage />} />
          <Route path="attendance-view" element={<AttendanceViewPage />} />
          <Route path="api-key" element={<ApiPage />} />
          <Route path="farmer-details" element={<FarmerDetailsPage />} />
          <Route path="dealer-details" element={<DealerDetailsPage />} />
          <Route path="leave-details" element={<LeaveDetailsPage />} />
           <Route path="app-id" element={<AppIdPage />} />
            <Route path="employee-route" element={<EmployeeRouteMapPage />} />
        </Route>

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
      

      {!shouldHideFooter && (
  <Footer />
)}

    </>
  );
};

export default App;
